var map = {
	"./gallery1.jpg": 64,
	"./gallery10.jpg": 722,
	"./gallery11.jpg": 527,
	"./gallery12.jpg": 680,
	"./gallery13.jpg": 861,
	"./gallery14.jpg": 798,
	"./gallery15.jpg": 283,
	"./gallery2.jpg": 399,
	"./gallery3.jpg": 349,
	"./gallery4.jpg": 961,
	"./gallery5.jpg": 236,
	"./gallery6.jpg": 715,
	"./gallery7.jpg": 190,
	"./gallery8.jpg": 45,
	"./gallery9.jpg": 216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 694;